module.exports = __webpack_public_path__ + "img/key_benefits-background.32034711.jpg";